const ComplementaryServices = [
  {
    name: 'Monitoring',
    id: 2,
  },
  {
    name: 'Documents',
    id: 3,
  },
];

export default ComplementaryServices;
